import {BifrostBackendNestApi} from "../gateways/BifrostBackendApi";
import appConfig from "../appconfig";

const PickupDateTimeRulesProvider = {
	async findAll() {
		const res = await BifrostBackendNestApi.get("/pickup-date-time-rules", {
			params: {
				"$limit": "10000",
				tenantId: appConfig.tenantId
			}
		});

		return res.data;
	},

	async insert({
		dateFilter,
		weekDayFilter,
		shopFilter,
		departmentFilter,
		productFilter,
		pickupRanges,
		name,
		createdById,
		createdByName,
		isWhitelist,
		isActive
	}, jwtToken) {
		return BifrostBackendNestApi.post(`/pickup-date-time-rules`, {
			tenantId: appConfig.tenantId,
			dateFilter,
			weekDayFilter,
			shopFilter,
			departmentFilter,
			productFilter,
			pickupRanges,
			name,
			createdById,
			createdByName,
			isWhitelist,
			isActive
		}, {
			headers: {
				Authorization: jwtToken
			}
		});
	},

	async delete(id, jwtToken) {
		return BifrostBackendNestApi.delete(`/pickup-date-time-rules/${id}`, {
			headers: {
				Authorization: jwtToken
			}
		});
	},

	async get(id, jwtToken) {
		return BifrostBackendNestApi.get(`/pickup-date-time-rules/${id}`, {
			headers: {
				Authorization: jwtToken
			}
		});
	},

	async partialUpdate(id, data, jwtToken){
		return BifrostBackendNestApi.patch(`/pickup-date-time-rules/${id}?tenantId=${data.tenantId}`, data, {
			headers: {
				Authorization: jwtToken
			}
		});
	},
	async update(id, data, jwtToken) {
		return BifrostBackendNestApi.put(`/pickup-date-time-rules/${id}?tenantId=${data.tenantId}`, data, {
			headers: {
				Authorization: jwtToken
			}
		});
	}
};

export default Object.freeze(PickupDateTimeRulesProvider);
